import { z } from 'zod';

export type ReportBid = {
    id: number,
    user: {
        id: number,
        last_name: string,
        first_name: string,
        second_name?: string | null,
        full_name: string,
        email: string,
    },
    dealer: {
        id: number,
        sap_code: string,
        name: string,
    },
    value: number,
    created_at: string,
};

const ReportBidSchema = z.object({
    id: z.number(),
    user: z.object({
        id: z.number(),
        last_name: z.string(),
        first_name: z.string(),
        second_name: z.string().nullable().optional(),
        full_name: z.string(),
        email: z.string(),
    }),
    dealer: z.object({
        id: z.number(),
        sap_code: z.string(),
        name: z.string(),
    }),
    value: z.number(),
    created_at: z.string(),
});

export const ReportBidsSchema = ReportBidSchema.array();
